import { api } from '../lib/api.js';
import { el, mount, toast } from '../lib/dom.js';
import { confirmDialog } from '../lib/modal.js';
import { clearOutbox, pendingCount } from '../lib/outbox.js';
import { isMuted, toggleMuted } from '../lib/sound.js';
import { navigate } from '../lib/router.js';
import * as wakeLock from '../lib/wakeLock.js';
import { renderNav } from './nav.js';

export async function renderAbout() {
  const buildAt = new Date(__APP_BUILD_AT__);
  const buildAtLabel = `${String(buildAt.getDate()).padStart(2, '0')}/${String(buildAt.getMonth() + 1).padStart(2, '0')}/${buildAt.getFullYear()} ${String(buildAt.getHours()).padStart(2, '0')}:${String(buildAt.getMinutes()).padStart(2, '0')}`;

  let online = '—';
  try {
    const h = await api.get<{ ok: boolean; db: string }>('/health');
    online = h.ok ? 'online' : 'offline';
    void h.db;
  } catch {
    online = 'offline';
  }
  const pending = await pendingCount().catch(() => 0);

  const muteState = el('span', { class: 'dim' }, [isMuted() ? 'mutado' : 'ativo']);

  const repoRow = __APP_REPO__
    ? el('a', { class: 'card row row--between', href: __APP_REPO__, target: '_blank', rel: 'noreferrer' }, [
        el('span', {}, ['Repositório']),
        el('span', { class: 'dim' }, [__APP_REPO__.replace(/^https?:\/\//, '')]),
      ])
    : null;

  mount(
    el('main', { class: 'view' }, [
      el('header', { class: 'session-head' }, [
        el('div', { class: 'h2' }, ['Sobre']),
        el('button', { class: 'btn btn--ghost', type: 'button', onclick: () => navigate('/') }, ['‹ Voltar']),
      ]),

      el('section', { class: 'card stack stack--sm', style: 'margin-bottom: var(--space-3)' }, [
        el('div', { class: 'row row--between' }, [
          el('span', { class: 'muted' }, ['Versão']),
          el('span', { style: 'font-variant-numeric: tabular-nums' }, [__APP_VERSION__]),
        ]),
        el('div', { class: 'row row--between' }, [
          el('span', { class: 'muted' }, ['Commit']),
          el('span', { style: 'font-variant-numeric: tabular-nums' }, [__APP_COMMIT__]),
        ]),
        el('div', { class: 'row row--between' }, [
          el('span', { class: 'muted' }, ['Build']),
          el('span', { class: 'dim' }, [buildAtLabel]),
        ]),
        el('div', { class: 'row row--between' }, [
          el('span', { class: 'muted' }, ['Servidor']),
          el('span', { style: `color: var(--${online === 'online' ? 'success' : 'danger'})` }, [online]),
        ]),
        el('div', { class: 'row row--between' }, [
          el('span', { class: 'muted' }, ['Wake Lock']),
          el(
            'span',
            { class: 'dim' },
            [wakeLock.isSupported() ? 'suportado' : 'não suportado'],
          ),
        ]),
        el('div', { class: 'row row--between' }, [
          el('span', { class: 'muted' }, ['Fila offline']),
          el(
            'span',
            { class: pending > 0 ? 'pill pill--accent' : 'dim' },
            [pending > 0 ? `${pending} pendentes` : 'vazia'],
          ),
        ]),
      ]),

      el('section', { class: 'stack stack--sm', style: 'margin-bottom: var(--space-3)' }, [
        el(
          'button',
          {
            class: 'btn',
            type: 'button',
            onclick: () => {
              const muted = toggleMuted();
              muteState.textContent = muted ? 'mutado' : 'ativo';
              toast(muted ? 'Som desligado' : 'Som ligado');
            },
          },
          [
            el('span', {}, ['Som ']),
            muteState,
          ],
        ),
        pending > 0
          ? el('button', {
              class: 'btn',
              type: 'button',
              onclick: async () => {
                const ok = await confirmDialog({
                  title: 'Limpar fila offline?',
                  message: `Apaga ${pending} entrada(s) presa(s) localmente. Use só se algum set não está chegando no servidor.`,
                  okLabel: 'Limpar',
                  danger: true,
                });
                if (!ok) return;
                const n = await clearOutbox();
                toast(`${n} entrada(s) limpa(s)`);
                void renderAbout();
              },
            }, ['Limpar fila offline'])
          : null,
        el('button', {
          class: 'btn',
          type: 'button',
          onclick: async () => {
            const ok = await confirmDialog({
              title: 'Sair da conta?',
              message: 'Você vai precisar digitar a senha de novo.',
              okLabel: 'Sair',
              danger: true,
            });
            if (!ok) return;
            try {
              await api.post('/auth/logout');
            } catch {
              /* ignore */
            }
            location.hash = '/login';
            location.reload();
          },
        }, ['Sair da conta']),
      ].filter(Boolean) as Node[]),

      repoRow,

      el('p', { class: 'dim', style: 'text-align: center; margin-top: var(--space-6); font-size: var(--text-sm)' }, [
        'mefit · single-user · Dynamic Double Progression',
      ]),

      renderNav('home'),
    ].filter(Boolean) as Node[]),
  );
}
